/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainEntitiesDocumentsDocumentType } from './FxIdDomainEntitiesDocumentsDocumentType';
import {
    FxIdDomainEntitiesDocumentsDocumentTypeFromJSON,
    FxIdDomainEntitiesDocumentsDocumentTypeFromJSONTyped,
    FxIdDomainEntitiesDocumentsDocumentTypeToJSON,
    FxIdDomainEntitiesDocumentsDocumentTypeToJSONTyped,
} from './FxIdDomainEntitiesDocumentsDocumentType';
import type { FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersion } from './FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersion';
import {
    FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionFromJSON,
    FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionFromJSONTyped,
    FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionToJSON,
    FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionToJSONTyped,
} from './FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersion';

/**
 * 
 * @export
 * @interface FxIdApplicationHandlersDocumentsGetDocumentDocumentDto
 */
export interface FxIdApplicationHandlersDocumentsGetDocumentDocumentDto {
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationHandlersDocumentsGetDocumentDocumentDto
     */
    Id: number;
    /**
     * 
     * @type {FxIdDomainEntitiesDocumentsDocumentType}
     * @memberof FxIdApplicationHandlersDocumentsGetDocumentDocumentDto
     */
    DocumentType: FxIdDomainEntitiesDocumentsDocumentType;
    /**
     * 
     * @type {Date}
     * @memberof FxIdApplicationHandlersDocumentsGetDocumentDocumentDto
     */
    CreatedAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof FxIdApplicationHandlersDocumentsGetDocumentDocumentDto
     */
    IsActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersDocumentsGetDocumentDocumentDto
     */
    GameSystemName: string;
    /**
     * 
     * @type {boolean}
     * @memberof FxIdApplicationHandlersDocumentsGetDocumentDocumentDto
     */
    IsAccepted: boolean;
    /**
     * 
     * @type {FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersion}
     * @memberof FxIdApplicationHandlersDocumentsGetDocumentDocumentDto
     */
    LatestVersion?: FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersion | null;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersDocumentsGetDocumentDocumentDto interface.
 */
export function instanceOfFxIdApplicationHandlersDocumentsGetDocumentDocumentDto(value: object): value is FxIdApplicationHandlersDocumentsGetDocumentDocumentDto {
    if (!('Id' in value) || value['Id'] === undefined) return false;
    if (!('DocumentType' in value) || value['DocumentType'] === undefined) return false;
    if (!('CreatedAt' in value) || value['CreatedAt'] === undefined) return false;
    if (!('IsActive' in value) || value['IsActive'] === undefined) return false;
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    if (!('IsAccepted' in value) || value['IsAccepted'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoFromJSON(json: any): FxIdApplicationHandlersDocumentsGetDocumentDocumentDto {
    return FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersDocumentsGetDocumentDocumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'Id': json['Id'],
        'DocumentType': FxIdDomainEntitiesDocumentsDocumentTypeFromJSON(json['DocumentType']),
        'CreatedAt': (new Date(json['CreatedAt'])),
        'IsActive': json['IsActive'],
        'GameSystemName': json['GameSystemName'],
        'IsAccepted': json['IsAccepted'],
        'LatestVersion': json['LatestVersion'] == null ? undefined : FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionFromJSON(json['LatestVersion']),
    };
}

export function FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoToJSON(json: any): FxIdApplicationHandlersDocumentsGetDocumentDocumentDto {
    return FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoToJSONTyped(json, false);
}

export function FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoToJSONTyped(value?: FxIdApplicationHandlersDocumentsGetDocumentDocumentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Id': value['Id'],
        'DocumentType': FxIdDomainEntitiesDocumentsDocumentTypeToJSON(value['DocumentType']),
        'CreatedAt': ((value['CreatedAt']).toISOString()),
        'IsActive': value['IsActive'],
        'GameSystemName': value['GameSystemName'],
        'IsAccepted': value['IsAccepted'],
        'LatestVersion': FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionToJSON(value['LatestVersion']),
    };
}

